module.exports = __webpack_public_path__ + "img/minifruehlingsrolleohnehintergrund.a2abf76f.png";